// removed by extract-text-webpack-plugin
module.exports = {"LanguageSwitch":"LanguageSwitch-module__LanguageSwitch__Lgffb","SpinnerWrapper":"LanguageSwitch-module__SpinnerWrapper__fy5Cr","SelectedItemWrapper":"LanguageSwitch-module__SelectedItemWrapper__1GUkC","CaretDownSvg":"LanguageSwitch-module__CaretDownSvg__5Jej8","ListWrapper":"LanguageSwitch-module__ListWrapper__15WE4","ListItemWrapper":"LanguageSwitch-module__ListItemWrapper__3vIZM","SelectedText":"LanguageSwitch-module__SelectedText__3Fy3j","ListItemText":"LanguageSwitch-module__ListItemText__2NY0B"};


//////////////////
// WEBPACK FOOTER
// ./src/components/LanguageSwitch/LanguageSwitch.module.css
// module id = 1725
// module chunks = 31